module.exports = __webpack_public_path__ + "img/botpress.02c31bca.png";